__turbopack_context__.v({
  "accordionSection": "CoreCard-module-scss-module__8iVxbq__accordionSection",
  "anchorAlias": "CoreCard-module-scss-module__8iVxbq__anchorAlias",
  "bullets": "CoreCard-module-scss-module__8iVxbq__bullets",
  "bulletsRichText": "CoreCard-module-scss-module__8iVxbq__bulletsRichText",
  "contentGrid": "CoreCard-module-scss-module__8iVxbq__contentGrid",
  "coreCard": "CoreCard-module-scss-module__8iVxbq__coreCard",
  "coreTitle": "CoreCard-module-scss-module__8iVxbq__coreTitle",
  "image": "CoreCard-module-scss-module__8iVxbq__image",
  "imageContainer": "CoreCard-module-scss-module__8iVxbq__imageContainer",
  "leftSide": "CoreCard-module-scss-module__8iVxbq__leftSide",
  "rightSide": "CoreCard-module-scss-module__8iVxbq__rightSide",
  "rowLabel": "CoreCard-module-scss-module__8iVxbq__rowLabel",
  "specTable": "CoreCard-module-scss-module__8iVxbq__specTable",
  "tableWrapper": "CoreCard-module-scss-module__8iVxbq__tableWrapper",
});
